import { configs } from "../configs";

const { serverUrl } = configs;

/** create a demand */
export const requestEntrepelung = (data) => {
    return fetch (`${serverUrl}/request/create`,{
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    })
}